import * as Yup from 'yup';

import { IMO_NUMBER_REGEX, MAX_FILE_SIZE_5MB, MAX_LENGTH_CHAR } from '@/common/constants';

export const editVesselShipOwnerSchema = Yup.object({
    type: Yup.array()
        .of(Yup.string().oneOf(['SIRE | BIRE', 'Vetting'], 'Invalid selection for type'))
        .min(1, 'At least one type is required'),
    imoRegNumber: Yup.string()
        .required('IMO / Registrasi number is required')
        .matches(IMO_NUMBER_REGEX, 'IMO / Registration number must contain only alphabets, digits, dots, slashes, and dashes.')
        .max(20, 'Max length is 20 characters'),
    vesselName: Yup.string()
        .required('Vessel name is required')
        //.matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
        .max(MAX_LENGTH_CHAR, 'Max length is 50 characters'),
    smc: Yup.mixed()
        .nullable()
        .test('fileSize', 'File size is too large', (value) => {
            if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                return false;
            }
            return true;
        }),
});
